import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { AuthenticationService } from 'src/modules/core/services';
import { OrganizationService } from 'src/modules/features/admin/services';
interface ICompanyNameModalContext {
  data: any;
  title?: string;
}
@Component({
  selector: 'app-company-name-modal',
  templateUrl: './company-name-modal.component.html',
  styleUrls: ['./company-name-modal.component.scss'],
})
export class CompanyNameModalComponent implements OnInit, OnDestroy {
  searchable: boolean = true;
  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pending: boolean;
  organization: any;
  organizationForm: FormGroup;
  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<ICompanyNameModalContext, void, void>,
    private organizationSvc: OrganizationService,
    private authSvc: AuthenticationService
  ) {
    this.organization = modal.context.data;
    this.organizationForm = fb.group({
      organizationShortName: [''],
      organizationLongName: [''],
      organizationDescription: [''],
    });
    this.organizationForm.patchValue(this.modal.context.data);
  }
  isFieldValid(field: string) {
    return (
      (!this.organizationForm.get(field).valid &&
        this.organizationForm.get(field).touched) ||
      (this.organizationForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }
  save() {
    this.pending = true;
    this.error = null;
    this.organizationSvc
      .update({
        organizationId: this.organization.organizationId,
        body: this.organizationForm.value,
      })
      .subscribe(
        (res) => {
          window.localStorage.setItem(
            'organization',
            JSON.stringify(
              Object.assign(
                {},
                { ...this.organization, ...this.organizationForm.value }
              )
            )
          );
          this.pending = false;
          this.success = 'Organization updated successfully';
          this.authSvc.setRefreshStorage('');
          setTimeout(() => {
            this.modal.approve({
              ...this.organization,
              ...this.organizationForm.value,
            });
          }, 2000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error;
        }
      );
  }

  nullify() {
    this.success = null;
    this.error = null;
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }
}

export class CompanyNameModal extends ComponentModalConfig<
  ICompanyNameModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Small) {
    super(CompanyNameModalComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
